import React from 'react';

const ImageViewContext = React.createContext<any>(null)

export default ImageViewContext